import { DeviceCounts } from "@tether-web-portal/types/DeviceCounts";
import { DeviceType } from "@tether-web-portal/types/DeviceType";
import { PropertyDeviceTypes } from "@tether-web-portal/types/PropertyDeviceTypes";
import { PulseMeterType } from "@tether-web-portal/types/PulseMeter";

export const deviceCountsToDeviceTypes = (deviceCounts: DeviceCounts): PropertyDeviceTypes => {
  if (!deviceCounts) return new Set();
  
  const { breakdowns = {}, ...devices } = deviceCounts;

  const deviceTypeCountEntries = Object.entries(devices) as [DeviceType, number][];
  const deviceTypesGreaterThanZero = deviceTypeCountEntries
    .filter(([deviceType, count]) => DeviceType[deviceType] && (count || 0) > 0)
    .map(([deviceType]) => deviceType);


  const pulseMeterCountEntries = Object.values(breakdowns).flatMap((breakdown) =>
    Object.entries(breakdown),
  ) as [PulseMeterType, number][];

  const pulseMeterTypesGreaterThanZero = pulseMeterCountEntries
    .filter(([pulseMeterType, count]) => PulseMeterType[pulseMeterType] && (count || 0) > 0)
    .map(([pulseMeterType]) => pulseMeterType);
  return new Set([...deviceTypesGreaterThanZero, ...pulseMeterTypesGreaterThanZero]);
};
